import * as React from "react";
import App, { AppInitialProps, AppContext } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import { connect } from "react-redux";
import { theme } from "@Definitions/Styled";
import { AppWithStore } from "@Interfaces";
import { wrapper } from "../Redux-Store";
import { config } from "@fortawesome/fontawesome-svg-core";
import "../styles/globals.scss";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles/";
import { UserActions } from "@Redux-Store/Actions/UserActions";
import { CartActions } from "@Redux-Store/Actions/CartActions";
import Cookies from "js-cookie";
import GlobalStyle from "@Static/fonts/GlobalStyles";
import Script from "next/script";
config.autoAddCss = false;

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
if (!SITE_URL) {
  throw new Error("NEXT_PUBLIC_SITE_URL is not set");
}

const CanonicalLink: React.FC = () => {
  const router = useRouter();

  const canonicalUrl = React.useMemo(() => {
    try {
      const path = router.asPath ? router.asPath.split("?")[0] : "/";
      return new URL(path, SITE_URL).toString();
    } catch {
      return SITE_URL;
    }
  }, [router.asPath]);

  return (
    <Head>
      {React.createElement("link", {
        rel: "canonical",
        href: canonicalUrl,
      })}
    </Head>
  );
};

class WebApp extends App<AppWithStore> {
  static async getInitialProps({
    Component,
    ctx,
  }: AppContext): Promise<AppInitialProps> {
    const pageProps = Component.getInitialProps
      ? await Component.getInitialProps(ctx)
      : {};

    return { pageProps };
  }

  componentDidMount() {
    const userId = Cookies.get("userId");
    const guestCartId = Cookies.get("guestCartId");

    if (userId) {
      this.props.GetMyDetails();
    }
    if (userId || guestCartId) this.props.GetMyCart();
  }

  render() {
    const { Component, pageProps } = this.props;
    return (
      <StyledEngineProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <CanonicalLink />
          {process.env.NODE_ENV == "production" ? (
            <>
              <Script id="gtag" async src="https://www.googletagmanager.com/gtag/js?id=G-KZJB0PE276" strategy="afterInteractive"></Script>
              <Script id="gtm-init" strategy="afterInteractive">
                {`window.dataLayer = window.dataLayer || [];
                  function gtag(){window.dataLayer.push(arguments);}
                  gtag('js', new Date());

                  gtag('config', 'G-KZJB0PE276');
                `}
              </Script>
            </>
          ) : (
            ""
          )}

          <Component {...pageProps} />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    GetMyCart: () => dispatch(CartActions.GetMyCart()),
    GetMyDetails: () => dispatch(UserActions.getMyDetails()),
  };
};

export default wrapper.withRedux(connect(null, mapDispatchToProps)(WebApp));
